import { render, staticRenderFns } from "./DK.vue?vue&type=template&id=bd9f4c4e&scoped=true"
import script from "./DK.vue?vue&type=script&lang=js"
export * from "./DK.vue?vue&type=script&lang=js"
import style0 from "./DK.vue?vue&type=style&index=0&id=bd9f4c4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd9f4c4e",
  null
  
)

export default component.exports